module.exports = __webpack_public_path__ + "static/media/team-john.b79bfbe1.jpg";